import React, { useContext, useEffect } from 'react';

import { RouteComponentProps } from '@reach/router';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { GlobalContext } from '../../../store';

import { InnerRouter } from '../../../components/AnimatedRouter';
import ClubLogo from '../../../components/ClubLogo';
import PlayerSubHeader from '../../../components/PlayerSubHeader';
import { TabMenu } from '../EventRoot/TabMenu';

interface IProps extends RouteComponentProps {
  clubId: string;
  children: React.ReactChild;
}

enum CLUB_SECTIONS {
  home,
  events,
  players,
  // Disabled due to https://code.talpor.com/club15/frontend/-/issues/888
  // standings,
  'club-info'
}

const titles: Record<string, string> = {
  'club-info': 'CLUB INFORMATION',
  events: 'EVENTS',
  home: '',
  players: 'PLAYER ROSTER',
  profile: 'PLAYER PROFILE'
  // Disabled due to https://code.talpor.com/club15/frontend/-/issues/888
  // standings: 'STANDINGS'
};

export const ClubRoot = (props: IProps) => {
  const { clubId, children, location } = props;
  const { actions, clubs, user } = useContext(GlobalContext);

  useEffect(() => {
    actions.clubs.get(Number(clubId));
  }, [clubId]);

  const club = clubs[Number(clubId)] || {};

  const groups = location ? /club\/[0-9]+\/([a-z\-]+)/g.exec(location.pathname || '') : [];
  const currentPage = groups && groups.length > 1 ? groups[1] : 'home';

  return (
    <div className="home club-home wrapper">
      <div>
        <PlayerSubHeader
          user={user}
          clubRoot={true}
          backgroundImage={club.backgroundImage}
          handicap={true}
        >
          <TabMenu
            clubId={clubId}
            selected={Number(CLUB_SECTIONS[currentPage as any])}
            sections={CLUB_SECTIONS}
          />

          <TransitionGroup className={`transition-group`}>
            <CSSTransition key={currentPage} classNames="fade" timeout={800}>
              {currentPage === 'home' ? (
                <div>
                  <ClubLogo src={club.profileImage || ''} className="main-logo" />
                </div>
              ) : (
                <div className="title-container">
                  <h2>{titles[currentPage]}</h2>
                </div>
              )}
            </CSSTransition>
          </TransitionGroup>
        </PlayerSubHeader>
      </div>

      <InnerRouter className="club-root" location={location}>
        {children}
      </InnerRouter>
    </div>
  );
};
